import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-survey-main-card',
  templateUrl: './survey-main-card.component.html',
  styleUrls: ['./survey-main-card.component.css']
})
export class SurveyMainCardComponent implements OnInit {

  constructor() { }

  @Input() survey;
  @Output() routeAction = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() share = new EventEmitter();


  ngOnInit() {
  }

  route(obj) {
    this.routeAction.emit(obj);

  }

  deleteSurvey(obj) {
    this.delete.emit(obj);

  }

  shareSurvey(obj) {
    this.share.emit(obj);
  

  }

}
